/**
 * Apple Design motion presets for admin + portal.
 * Mapped from WWDC “Designing Fluid Interfaces” → Framer Motion springs.
 *
 * Defaults: critically damped (no overshoot). Bounce only after momentum.
 */

import type { Transition } from "framer-motion";

/** Critically damped — menus, page chrome, chevrons, default UI. */
export const ADMIN_SPRING_DEFAULT: Transition = {
  type: "spring",
  bounce: 0,
  duration: 0.35,
};

/** Snappy settle — buttons / press release. */
export const ADMIN_SPRING_SNAP: Transition = {
  type: "spring",
  bounce: 0,
  duration: 0.28,
};

/** Soft sheet/drawer feel (slight under-damp when momentum applies). */
export const ADMIN_SPRING_SHEET: Transition = {
  type: "spring",
  bounce: 0.12,
  duration: 0.4,
};

/** Page enter — opacity only under reduced-motion consumers. */
export const ADMIN_PAGE_ENTER: Transition = {
  type: "spring",
  bounce: 0,
  duration: 0.32,
};

export const ADMIN_PRESS_SCALE = 0.97;
export const ADMIN_CARD_PRESS_SCALE = 0.985;
export const ADMIN_HOVER_SCALE = 1.01;

/** Safe client check for prefers-reduced-motion. */
export function prefersReducedMotion(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/** Transition that becomes an instant cross-fade when reduced motion is on. */
export function adminTransition(base: Transition = ADMIN_SPRING_DEFAULT): Transition {
  if (prefersReducedMotion()) {
    return { duration: 0.15, ease: "easeOut" };
  }
  return base;
}
